module.exports = "<div *ngIf=\"routesService.visiblePageLoader\" class=\"bounce-loader\" id=\"loading-dots\">\r\n    <div class=\"bounce1\"></div>\r\n    <div class=\"bounce2\"></div>\r\n    <div class=\"bounce3\"></div>\r\n</div>\r\n<router-outlet></router-outlet>\r\n<div (window:beforeunload)=\"clearMemory()\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/+app/app.component.html
// module id = 641
// module chunks = 0